import React, { useState } from 'react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate';
import { DatePicker } from '../../shared/DatePicker';
import { GetCumulativeDetailedIncomeReport } from '../../../api/services/finance';
import CheckboxWrapper from '../../shared/Checkbox';
import PropTypes from "prop-types";
import { useTextResources } from '../../../language'

const CumulativeDetailedIncomeReport = ({ HotelID }) => {
    const [myTransformedData, setData] = useState([]);
    const [search, setSearchParams] = useState({});
    const text = useTextResources()

    const handleSearchComplete = (data, searchState) => {
        setSearchParams(searchState)
        setData(data)
    }
    const formatter = ({ value }) => {
        return value.toFixed(2)
    }

    const gridOptions = {
        search: {
            title: text("CumulativeDetailedIncomeReport"),
            fields: [
                <DatePicker
                    type="basic"
                    label={text("Date")}
                    key="Date"
                />,
                <CheckboxWrapper
                    label={text("ClickToCompare")}
                    key="ComparedToLastYear"
                />
            ],
            api: GetCumulativeDetailedIncomeReport,
            spec: {
                HotelID: HotelID
            }
        },
        /* eslint-disable react/display-name */
        grid: {
            columns: [
                { name: 'TransactionCodeGroupName', title: text('TransactionCode') },
                { name: 'TransactionGroupName', title: text('TransactionGroupName') },
                { name: 'Period1', title: text('Daily'), formatter },
                { name: 'Period2', title: text('Monthly'), formatter },
                { name: 'Period3', title: text('Yearly'), formatter },
                { name: 'Period4', title: text('DailyLastYear'), formatter },
                { name: 'Period5', title: text('MonthlyLastYear'), formatter },
                { name: 'Period6', title: text('YearlyLastYear'), formatter }
            ],
            customOptions: {
                overrideData: true,
                hidden: {
                    hiddenColumns: search.ComparedToLastYear ?
                        [{ columnName: 'TransactionGroupName' }] :
                        [{ columnName: 'Period4' }, { columnName: 'Period5' }, { columnName: 'Period6' }, { columnName: 'TransactionGroupName' }]
                }
            },
            selectable: false,
            tree: {
                getChildRows: (row, rootRows) => {
                    const childRows = rootRows.filter(r => r.ParentTransactionCodeGroupID === (row ? row.TransactionCodeGroupID : null));
                    return childRows.length ? childRows : null;
                },
                treeColumnName: "TransactionCodeGroupName"
            },
            pdf: true,
            export: true,
            excel: {
                grouping: [{ columnName: "TransactionGroupName" }],
            },
            customCellCallback: ({ row }) => {
                if (row.IsStatisticsHeader) {
                    return <div></div>
                } else
                    return false
            },
            customTreeCellCallback: ({ row }) => {
                if (row.IsStatisticsHeader) {
                    return <div style={{ fontWeight: "bold", fontSize: "larger" }}>{row.TransactionCodeGroupName}</div>
                } else
                    return false
            },
        }
        /* eslint-enable react/display-name */
    }

    return (<GridSearchTemplate options={gridOptions} onSearchComplete={handleSearchComplete} data={myTransformedData} />)
}
CumulativeDetailedIncomeReport.propTypes = {
    HotelID: PropTypes.number
}
export default CumulativeDetailedIncomeReport